import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { UserPermissionService } from '../../../shared/services/user-permission.service';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private userPermissionService: UserPermissionService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const token = localStorage.getItem('token') || '';

    if (!token) {
      this.router.navigateByUrl('auth');
      return of(false);
    }

    return this.authService.verifyToken(token).pipe(
      timeout(environment?.timeout),
      map((isValid: boolean) => {
        if (!isValid) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.clear()
          window.location.href = environment.BASE_URL + 'auth/login';
        }
        this.userPermissionService.loadPermission();
        return true;
      }),
      catchError((error) => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.clear()
        window.location.href = environment.BASE_URL + 'auth/login';
        return of(false);
      })
    );
  }
}
